import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const PrintContent = forwardRef(({ data, invObj, viewProducts, viewPayments }, ref) => {
    const totalAmount = viewProducts.reduce((total, item) => {
      const itemTotal =
        (item.Quantity || 0) * (item.UnitPrice || 0) +
        (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100) *
          (item.Quantity || 0) *
          (item.UnitPrice || 0);
      return total + itemTotal;
    }, 0);

    const totalPaidAmount = viewPayments.reduce(
      (totalPaidAmt, item) => totalPaidAmt + (item.PaidAmount || 0),
      0
    );

    const totalProdsAmount = viewProducts.reduce((total, item) => {
      const productTotal = 
        (item.Quantity || 0) * (item.UnitPrice || 0) +
        (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100) *
        (item.Quantity || 0) *
        (item.UnitPrice || 0);
        
      return total + productTotal;
    }, 0);
    
    const formattedProdsTotal = totalProdsAmount.toFixed(2);    

    const numberOfItems = viewProducts.length;

    const TermsAndConditions = {
      "Note" : "Note: No guarantee for stone, fancy, kids items and No Exchange.",
      "Description": "Composition taxable person not eligible to collect tax on supplies."
    };

    // console.log(data, 'dataaa')
    // console.log(invObj, 'invObj')
    // console.log(viewProducts, 'viewprods')
    // console.log(viewPayments, 'viewPayments')

    return (
      <div
        ref={ref}
        style={{
          border: "2px solid #000",
          padding: "20px",
          width: "90%",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        <div id="page-wrap" style={{ width: "100%" }}>
          <table
            width="100%"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              marginBottom: "20px",
            }}
            cellSpacing="0"
            cellPadding="0"
          >
            <tbody>
              <tr>
                <td style={{ height: "30px" }} valign="top">
                  <h2
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      marginTop: "3px",
                      marginBottom: "3px",
                      fontSize: "18px",
                    }}
                  >
                    CC TAX INVOICE
                  </h2>
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{
                    fontSize: "14px",
                    fontWeight: "normal",
                    paddingBottom: "10px",
                    height: "30px",
                    verticalAlign: "top",
                    color: "#000",
                  }}
                >
                  {data?.StoreName ? `PI-${data.StoreName}` : ""}
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{
                    fontSize: "18px",
                    paddingBottom: "5px",
                    height: "25px",
                  }}
                  valign="top"
                >
                  {data?.SupplierAddress}
                </td>
              </tr>
            </tbody>
          </table>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: "20px",
              borderTop: "1px solid #000",
              paddingTop: "10px",
            }}
          >
            <div style={{ width: "49%", paddingRight: "10px" }}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  Invoice Details:
                </li>
                <li>
                  GSTIN Number:{" "}
                  {Array.isArray(data?.GSTIN) && data?.GSTIN[0]
                    ? data.GSTIN[0]
                    : "N/A"}
                </li>
                <li>Invoice Number: INV-{viewProducts[0]?.AutoGenTransactionNo}</li>
                <li>Invoice Date: {new Date(data?.InvoiceDate).toLocaleDateString('en-GB')}</li>
                <li>Sales Man: {data?.SupplierName}</li>
              </ul>
            </div>
            <div
              style={{
                width: "1px",
                backgroundColor: "#000",
                marginRight: "10px",
              }}
            />
            <div style={{ width: "49%", paddingLeft: "10px" }}>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                <li style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  Supplier Details:
                </li>
                <li>Name: {data?.SupplierName || "N/A"}</li>
                <li>Mobile NO: {data?.SupplierPhoneNo || "N/A"}</li>
                <li>Email ID: {data?.SupplierEmail || "N/A"}</li>
                <li>
                  GSTIN:{" "}
                  {Array.isArray(data?.GSTIN) && data?.GSTIN[0]
                    ? data.GSTIN[0]
                    : "N/A"}
                </li>
                <li>Address: {data?.SupplierAddress || "N/A"}</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <h4>Products</h4>
            <table
              style={{
                width: "100%",
                border: "1px solid #000",
                borderCollapse: "collapse",
                marginBottom: "20px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    S.No
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Item
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Quantity
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    CGST
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    SGST
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {viewProducts.length > 0 ? (
                  viewProducts?.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "8px",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "8px",
                        }}
                      >
                        {item.Productname}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "8px",
                        }}
                      >
                        {item.Quantity}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "8px",
                        }}
                      >
                        {item.CGSTRate}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "8px",
                        }}
                      >
                        {item.SGSTRate}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "center",
                          padding: "8px",
                        }}
                      >
                        {(
                          (item.Quantity || 0) * (item.UnitPrice || 0) +
                          (((item.CGSTRate || 0) + (item.SGSTRate || 0)) /
                            100) *
                            (item.Quantity || 0) *
                            (item.UnitPrice || 0)
                        ).toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{ textAlign: "center", padding: "8px" }}
                    >
                      No Products Available
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td
                    colSpan="5"
                    style={{
                      border: "1px solid black",
                      textAlign: "right",
                      padding: "8px",
                    }}
                  >
                    Total:
                  </td>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      padding: "8px",
                    }}
                  >
                    {formattedProdsTotal ? formattedProdsTotal : "N/A"}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <h4>Payments</h4>
            <table
              style={{
                width: "100%",
                border: "1px solid #000",
                borderCollapse: "collapse",
                marginBottom: "20px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    S.No
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Payment Type
                  </th>
                  <th style={{ border: "1px solid #000", padding: "8px" }}>
                    Paid
                  </th>
                </tr>
              </thead>
              <tbody>
                {viewPayments?.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {item.PaymentTypeName}
                    </td>
                    <td
                      style={{
                        border: "1px solid black",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      {item.PaidAmount}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td
                    colSpan="2"
                    style={{
                      border: "1px solid black",
                      textAlign: "right",
                      padding: "8px",
                    }}
                  >
                    Total Paid:
                  </td>
                  <td
                    style={{
                      border: "1px solid black",
                      textAlign: "center",
                      padding: "8px",
                    }}
                  >
                    {totalPaidAmount ? totalPaidAmount : "N/A"}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <h3>No Of Items: {numberOfItems ? numberOfItems : "N/A"}</h3>
            <h3>
              Discount:{" "}
              {invObj?.DiscountAmount ? invObj?.DiscountAmount : "N/A"}
            </h3>
            <h3>
              Total:{" "}
              {totalAmount ? totalAmount - invObj?.DiscountAmount : "N/A"}
            </h3>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <h6>Terms & Conditions:</h6>
            <p>{TermsAndConditions.Note}</p>
            <p>{TermsAndConditions.Description}</p>
          </div>
        </div>
      </div>
    );
  }
);

PrintContent.displayName = "PrintContent";

PrintContent.propTypes = {
  data: PropTypes.shape({
    StoreName: PropTypes.string.isRequired,
    GSTIN: PropTypes.arrayOf(PropTypes.string).isRequired,
    SupplierName: PropTypes.string.isRequired,
    SupplierPhoneNo: PropTypes.string.isRequired,
    SupplierEmail: PropTypes.string.isRequired,
    SupplierAddress: PropTypes.string.isRequired,
    InvoiceDate: PropTypes.string.isRequired,
  }).isRequired,
  viewProducts: PropTypes.arrayOf(
    PropTypes.shape({
      AutoGenTransactionNo: PropTypes.string.isRequired,
      Productname: PropTypes.string,
      Quantity: PropTypes.number,
      UnitPrice: PropTypes.number,
      CGSTRate: PropTypes.number,
      SGSTRate: PropTypes.number,
      DiscountAmount: PropTypes.number,
    })
  ).isRequired,
  viewPayments: PropTypes.arrayOf(
    PropTypes.shape({
      PaymentTypeName: PropTypes.string,
      PaidAmount: PropTypes.number,
    })
  ).isRequired,
  invObj: PropTypes.arrayOf(
    PropTypes.shape({
      DiscountAmount: PropTypes.number,
    })
  ).isRequired,
};

export default PrintContent;
